import {
  CHECK_ACC_REQUESTING,
  CHECK_ACC_REQUEST_ERROR,
  CHECK_ACC_REQUEST_SUCCESS,
  DATA_ACCOUNT_SET,
} from "./constants";

export const setToast = function setToast(resData) {
  return {
    type: "SHOW_TOAST",
    resData,
  };
};

export const setDataAccount = function setToast(resData) {
  return {
    type: DATA_ACCOUNT_SET,
    resData,
  };
};

export const checkAccountRequest = function checkAccountRequest(data) {
  return {
    type: CHECK_ACC_REQUESTING,
    data,
  };
};

export const checkAccountRequestSuccess = function checkAccountRequestSuccess(
  resData,
) {
  return {
    type: CHECK_ACC_REQUEST_SUCCESS,
    resData,
  };
};

export const checkAccountRequestError = function checkAccountRequestError(
  error,
) {
  return {
    type: CHECK_ACC_REQUEST_ERROR,
    error,
  };
};
